import { render } from "./Goal.vue?vue&type=template&id=5ed870a8"
import script from "./Goal.vue?vue&type=script&lang=js"
export * from "./Goal.vue?vue&type=script&lang=js"

import "./Goal.vue?vue&type=style&index=0&id=5ed870a8&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__